var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        /* jshint esversion: 6 */

        var UiPhoneNumberWidget = function () {
            function UiPhoneNumberWidget(root) {
                _classCallCheck(this, UiPhoneNumberWidget);

                this.root = root;
                this.input = root.querySelector('[data-ui-phone-number-input]');
                this.codeValueInput = root.querySelector('[data-ui-phone-number-code-value]');
                this.hint = root.querySelector('[data-ui-phone-number-hint]');
                this.toggleLabel = root.querySelector('.ui-select__toggle-label');
                this.mask = null;

                this.initMask();
                this.syncSelectedCodeView();
                this.bindEvents();
            }

            _createClass(UiPhoneNumberWidget, [{
                key: "initMask",
                value: function initMask() {
                    if (!this.input || typeof IMask !== 'function') {
                        return;
                    }

                    this.mask = IMask(this.input, {
                        mask: this.normalizeMask(this.root.dataset.mask || ''),
                        definitions: {
                            X: {
                                mask: '0',
                                displayChar: 'X',
                                placeholderChar: '#'
                            }
                        },
                        lazy: false,
                        overwrite: 'shift'
                    });
                }
            }, {
                key: "bindEvents",
                value: function bindEvents() {
                    var _this = this;

                    this.root.addEventListener('ui-select:change', function (event) {
                        _this.handleCodeChange(event.detail ? event.detail.value : '', event.detail ? event.detail.contentId : '');
                    });

                    if (this.input) {
                        this.input.addEventListener('input', function () {
                            _this.clearError();
                            _this.dispatchChange();
                        });
                    }

                    this.root.addEventListener('ui-phone-number:set-error', function (event) {
                        _this.setError(event.detail && event.detail.message ? event.detail.message : '');
                    });

                    this.root.addEventListener('ui-phone-number:clear-error', function () {
                        _this.clearError();
                    });
                }
            }, {
                key: "handleCodeChange",
                value: function handleCodeChange(value) {
                    var contentId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

                    var codeData = this.getSelectedCodeData(value, contentId);

                    if (!codeData) {
                        return;
                    }

                    if (this.codeValueInput) {
                        this.codeValueInput.value = codeData.code;
                    }

                    if (this.input) {
                        this.input.value = '';
                    }

                    this.root.dataset.mask = codeData.mask;
                    this.root.dataset.minLength = codeData.minLength;
                    this.syncSelectedCodeView(value, contentId);
                    this.updateMask(codeData.mask);
                    this.clearError();
                    this.dispatchChange();
                }
            }, {
                key: "updateMask",
                value: function updateMask(mask) {
                    if (!this.mask) {
                        return;
                    }

                    this.mask.updateOptions({
                        mask: this.normalizeMask(mask)
                    });
                    this.mask.updateValue();
                }
            }, {
                key: "getSelectedCodeData",
                value: function getSelectedCodeData(value) {
                    var contentId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

                    var option = Array.from(this.getCodeOptions(contentId)).find(function (item) {
                        return String(item.value) === String(value);
                    });

                    if (!option) {
                        return null;
                    }

                    var label = option.closest('.ui-select__option');
                    var code = label ? label.querySelector('.code') : null;

                    if (!code) {
                        return null;
                    }

                    return {
                        code: this.normalizeCode(code.textContent || ''),
                        mask: code.dataset.mask || '(000) 000-00-00',
                        minLength: code.dataset.min || '10'
                    };
                }
            }, {
                key: "syncSelectedCodeView",
                value: function syncSelectedCodeView() {
                    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
                    var contentId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

                    if (!this.toggleLabel) {
                        return;
                    }

                    var selectedValue = value === null ? this.getSelectedCodeValue() : value;
                    var option = Array.from(this.getCodeOptions(contentId)).find(function (item) {
                        return String(item.value) === String(selectedValue);
                    });
                    var optionNode = option ? option.closest('.ui-select__option') : null;
                    var flag = optionNode ? optionNode.querySelector('.phone-prefix') : null;
                    var code = optionNode ? optionNode.querySelector('.code') : null;

                    if (flag) {
                        this.toggleLabel.style.setProperty('--ui-phone-number-flag', 'url("' + flag.getAttribute('src') + '")');
                        this.toggleLabel.classList.add('ui-phone-number__code-label_has-flag');
                    } else {
                        this.toggleLabel.style.removeProperty('--ui-phone-number-flag');
                        this.toggleLabel.classList.remove('ui-phone-number__code-label_has-flag');
                    }

                    if (code) {
                        this.toggleLabel.textContent = code.textContent.trim();
                    }
                }
            }, {
                key: "getCodeOptions",
                value: function getCodeOptions() {
                    var contentId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

                    var content = contentId ? document.getElementById(contentId) : null;

                    if (content) {
                        return content.querySelectorAll('.ui-select__option-value');
                    }

                    return this.root.querySelectorAll('.ui-select__option-value');
                }
            }, {
                key: "getSelectedCodeValue",
                value: function getSelectedCodeValue() {
                    var valueInput = this.root.querySelector('.ui-select__toggle-value');

                    return valueInput ? valueInput.value : '';
                }
            }, {
                key: "normalizeMask",
                value: function normalizeMask(mask) {
                    return mask ? mask.replace(/9/g, '0') : '(000) 000-00-00';
                }
            }, {
                key: "normalizeCode",
                value: function normalizeCode(value) {
                    return String(value || '').replace(/\D/g, '');
                }
            }, {
                key: "getPhoneValue",
                value: function getPhoneValue() {
                    if (this.mask) {
                        return this.mask.unmaskedValue;
                    }

                    return this.input ? this.input.value.replace(/\D/g, '') : '';
                }
            }, {
                key: "getCodeValue",
                value: function getCodeValue() {
                    return this.codeValueInput ? this.codeValueInput.value : '';
                }
            }, {
                key: "setError",
                value: function setError(message) {
                    this.root.classList.add('ui-phone-number_error');

                    if (this.hint) {
                        this.hint.textContent = message;
                    }
                }
            }, {
                key: "clearError",
                value: function clearError() {
                    this.root.classList.remove('ui-phone-number_error');

                    if (this.hint) {
                        this.hint.textContent = this.root.dataset.hint || '';
                    }
                }
            }, {
                key: "dispatchChange",
                value: function dispatchChange() {
                    var phone = this.getPhoneValue();
                    var code = this.getCodeValue();

                    this.root.dispatchEvent(new CustomEvent('ui-phone-number:change', {
                        bubbles: true,
                        detail: {
                            code: code,
                            phone: phone,
                            fullPhone: code + phone,
                            minLength: Number(this.root.dataset.minLength || 0),
                            isComplete: this.mask ? this.mask.masked.isComplete : false
                        }
                    }));
                }
            }]);

            return UiPhoneNumberWidget;
        }();

        function initUiPhoneNumberWidgets() {
            document.querySelectorAll('[data-ui-phone-number]').forEach(function (root) {
                if (root.uiPhoneNumberWidget) {
                    return;
                }

                root.uiPhoneNumberWidget = new UiPhoneNumberWidget(root);
            });
        }

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', initUiPhoneNumberWidgets);
        } else {
            initUiPhoneNumberWidgets();
        }

        window.UiPhoneNumberWidget = UiPhoneNumberWidget;
    }, {}] }, {}, [1]);